import React from "react";
import { Button, Modal } from "react-bootstrap";
import './ChangeLanguageDialog.css';
import {updateLanguage ,getMessage} from "../../Common/ChangLanguage"


class ChangeLanguageDialog extends React.Component{
    constructor(props) {
        super(props);
        let lang = !localStorage.getItem('lang') ? 'en' : localStorage.getItem('lang');
        this.handleClose = this.handleClose.bind(this);
        this.updateLang = this.updateLang.bind(this);
        this.state = {
            lang: lang,
            message: getMessage(lang),
        }
    }
    handleClose(){  
        this.props.handleClose();
    }

    updateLang(){
        let langInfo = document.getElementById("lang").value;
        if (this.state.lang === langInfo){
            this.handleClose()
        }else{
            updateLanguage(this,langInfo);
            this.handleClose();
            window.location.reload();
        }
    };

    render(){
        return (
            <Modal id="changeLanguage" show={this.props.show} onHide={this.handleClose} centered backdrop="static" >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {<div className="content-title">
                            <span>{this.props.intl.formatMessage({ id: "change_language" })}</span>
                        </div>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="form">
                        <div className="label"><span>{this.props.intl.formatMessage({ id: "language" })}</span></div>
                        <div className="inputField">
                            <select id="lang" defaultValue={this.state.lang}>
                                <option value="en">{"English"}</option>
                                {/* <option value="fr">{"Français"}</option>
                                <option value="de">{"Deutsch"}</option>
                                <option value="it">{"Italiano"}</option> */}
                                <option value="ja">{"日本語"}</option>
                                {/* <option value="es">{"Español"}</option> */}
                            </select>
                        </div>    
                </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className="primaryBtn" onClick={this.updateLang}>{this.props.intl.formatMessage({ id: "header_apply" })}</Button>
                    <Button variant="secondary" className="cancelBtn" onClick={this.handleClose}>{this.props.intl.formatMessage({ id: "header_close" })}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ChangeLanguageDialog;
